"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingHistoryUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var section_ids_1 = require("../../../section-ids");
var date_1 = require("../../../utils/date");
var components_1 = require("./components");
var BillingHistoryUI = function (_a) {
    var _b;
    var historyLegacy = _a.historyLegacy, latestBillingPeriod = _a.latestBillingPeriod;
    var _c = (0, core_1.useComponents)(), Heading1 = _c.Heading1, Card = _c.Card, PrimaryCTALink = _c.PrimaryCTALink, InternalLink = _c.InternalLink, P = _c.P, Stack = _c.Stack, SummaryCard = _c.SummaryCard;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _d.Copy, copy = _d.copy;
    var billingDetails = (0, core_1.useLinks)().billingDetails;
    var latestPeriodEndDate = latestBillingPeriod &&
        latestBillingPeriod.billingSummary &&
        'latestPeriod' in latestBillingPeriod.billingSummary
        ? latestBillingPeriod.billingSummary.latestPeriod.data.end
        : undefined;
    var formattedDate = (0, date_1.getFormattedEndDate)(latestPeriodEndDate);
    if (!historyLegacy) {
        return react_1.default.createElement(components_1.Error, null);
    }
    var legacyEmpty = historyLegacy &&
        historyLegacy.legacyBillingHistory.length === 0 &&
        historyLegacy.orionBillingHistory.length === 0;
    return (react_1.default.createElement("section", { "data-testid": section_ids_1.BILLING_HISTORY },
        react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Heading1, null, copy('title')),
                        react_1.default.createElement(Copy, { copyKey: "headerText" }),
                        historyLegacy && (react_1.default.createElement(P, null,
                            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_CURRENT_BILLING_PERIOD, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                                react_1.default.createElement(PrimaryCTALink, { as: InternalLink, href: billingDetails(), "data-testid": "billing-history-current-period-link" }, copy('viewCurrentBillingPeriod')))))),
                    react_1.default.createElement(core_1.FeedbackPrompt, { id: "billingHistory", probability: 25, label: copy('feedbackPromptLabelBillingHistory') }))),
            legacyEmpty ? (react_1.default.createElement(SummaryCard, { heading: react_1.default.createElement(Copy, { copyKey: "noBillingTitle" }), "data-testid": "empty-billing-period-card", icon: "no-bill" },
                react_1.default.createElement(Copy, { copyKey: "periodEndText", values: { endDate: formattedDate } }))) : historyLegacy ? (react_1.default.createElement(components_1.BillingHistoryList, { billingHistory: historyLegacy })) : null)));
};
exports.BillingHistoryUI = BillingHistoryUI;
